import { put, takeLatest } from "redux-saga/effects";
import { getCRMLevelInfoApi } from "store/api/InfoLoyaltyApi";
import { GET_CRM_LEVEL_INFO_ACTION } from "../../actions/InfoLoyaltyPageAction/actionTypes";

import * as infoLoyaltyPageAction from "../../actions/InfoLoyaltyPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getCRMLevelInfo() {
	const res = yield getCRMLevelInfoApi();
	try {
		if (res?.code === 0) {
			yield put(infoLoyaltyPageAction.setCRMLevelInfo(res?.data));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getCRMLevelInfoSaga() {
	yield takeLatest(GET_CRM_LEVEL_INFO_ACTION, getCRMLevelInfo);
}

export default getCRMLevelInfoSaga;
